import React from 'react';
import { motion } from 'framer-motion';
const applications = [{
  sector: 'CLÍNICAS',
  flow: 'WhatsApp → IA → Calificación → Agenda → Seguimiento'
}, {
  sector: 'INMOBILIARIAS',
  flow: 'Consulta → Propiedad → Calificación → Visita → CRM'
}, {
  sector: 'SERVICIOS',
  flow: 'Solicitud → IA → Información → Cotización → Seguimiento'
}, {
  sector: 'EDUCACIÓN',
  flow: 'Interés → Programa → Calificación → Asesor → Matrícula'
}, {
  sector: 'E-COMMERCE',
  flow: 'Producto → Consulta → IA → Compra → Postventa'
}, {
  sector: 'SERVICIOS PROFESIONALES',
  flow: 'Lead → IA → CRM → Reunión → Seguimiento'
}];
export function Applications() {
  return <section className="bg-arena py-[40px] md:py-[56px]" data-id="element-53" data-mp="6zb0fwfjxv17">
      <div className="max-w-[1000px] mx-auto px-6 md:px-20" data-id="element-54" data-mp="bzf8qz6b3jgc">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="text-center mb-8" data-id="element-55" data-mp="zq1cwfd6wjl2">
          <h2 className="font-display text-[26px] md:text-[36px] font-bold text-carbon mb-2" data-id="element-56" data-mp="2y0jdeij8ieut">
            Una arquitectura. Diferentes empresas.
          </h2>
          <p className="font-body text-[13px] text-carbon/40 italic" data-id="element-57" data-mp="37qb7zcrc37za">
            Misma arquitectura. Diferente lógica empresarial.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-2.5" data-id="element-58" data-mp="3gqrbgm82uf45">
          {applications.map((app, idx) => <motion.div key={app.sector} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.35,
          ease: 'easeOut',
          delay: idx * 0.04
        }} className="group bg-arena-dark border border-carbon/10 hover:border-verde/40 hover:bg-carbon/[0.03] hover:-translate-y-[1px] rounded-[12px] px-5 py-4 transition-all duration-200" data-id="element-59" data-mp="3brwrvi2acmiz" data-mpi={idx}>
              <span className="flex items-center gap-2 mb-1.5" data-id="element-60" data-mp="2h08e7hdpqbjd">
                <span className="w-1.5 h-1.5 rounded-full bg-carbon/20 group-hover:bg-verde transition-colors duration-200" data-id="element-61" data-mp="2h1ruh7zdcml5" />
                <span className="font-body text-[12px] font-semibold uppercase tracking-[0.08em] text-carbon/70" data-id="element-62" data-mp="2q0n12l6bryoz">
                  {app.sector}
                </span>
              </span>
              <span className="block font-body text-[13px] text-carbon/45 group-hover:text-verde transition-colors duration-200" data-id="element-63" data-mp="2uxdh58i4quae">
                {app.flow}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}